import * as React from 'react';
import ReactPlayer from 'react-player';

import { General } from './../parentClasses/general';
import { Helper } from './../utils/helper';

const logo = require('./../images/gjr_white.png');

class ViewVideo extends General {
  isComponentMounted = false;

  props: {
    id: string;
    isModal?: boolean;
    identifier?: string;
    subIdentifier?: string;
    videoUrl: string;
    videoTitlePrefix?: string;
    videoTitle?: string;
    autoPlay?: boolean;
    imgUrl?: string;
    displayFooterLogo?: boolean;
    trackStudentTasks?: boolean;
    trackStudentEmplSkills?: boolean;
    trackStudentEmplSkillTopicId?: string;
    containerStore?: any;
    onClose?(id: string): void;
  };

  static defaultProps = {
    isModal: true,
    identifier: '',
    subIdentifier: '',
    videoTitlePrefix: 'Video',
    videoTitle: '',
    autoPlay: false,
    imgUrl: '',
    displayFooterLogo: false,
    trackStudentTasks: false,
    trackStudentEmplSkills: false,
    trackStudentEmplSkillTopicId: '',
    containerStore: undefined,
    onClose: undefined
  };

  constructor(props: React.Props<any>) {
    super(props);
    this.state = {
      listenersSet: false,
      showVideo: false,
      playVideo: false
    };
  }

  componentDidMount() {
    this.isComponentMounted = true;

    this.setListeners();
  }

  componentWillUnmount() {
    this.isComponentMounted = false;
  }

  render() {
    if (this.props.isModal && !this.state.showVideo) {
      return (
        <div id={this.props.id} className="modal fade" role="dialog"></div>
      );
    }
    if (this.props.isModal && this.state.showVideo) {
      return (
        <div id={this.props.id} className="modal fade" role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                {(
                  this.props.videoTitle === '' &&
                  <h5 className="modal-title text-left">Video</h5>
                )}
                {(
                  this.props.videoTitle !== '' &&
                  <h5 className="modal-title text-left">{this.props.videoTitlePrefix}: {this.props.videoTitle}</h5>
                )}
              </div>
              <div className="modal-body">
                {this.getVideoPlayer()}
              </div>
              {(
                !this.props.displayFooterLogo &&
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={this.onCloseEvent}>Close</button>
                </div>
              )}
              {(
                this.props.displayFooterLogo &&
                <div className="my-3 mx-3">
                  <div className="float-left">
                    <img src={logo} className="w-75 img-fluid"/>
                  </div>
                  <div className="float-right">
                    <button type="button" className="btn btn-secondary" onClick={this.onCloseEvent}>Close</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }
    if (!this.props.isModal && this.state.showVideo) {
      return (
        <div id={this.props.id}>
          {this.getVideoPlayer()}
        </div>
      );
    }
    return null;
  }

  // events
  private onCloseEvent = (e: React.MouseEvent<any>) => {
    this.toggleVideoFlag(false, false);
    if (this.props.onClose && this.isComponentMounted) {
      this.props.onClose(this.props.id);
    }
  }

  // others
  private setListeners = () => {
    if (this.props.isModal) {
      const docElement = document.getElementById(this.props.id);
      if (docElement && !this.state.listenersSet) {
        const newObj = Object.assign({}, this.state,  { listenersSet: true });
        if (this.isComponentMounted) {
          this.setState(newObj, () => {
            // tslint:disable:align
            docElement.addEventListener('shown.bs.modal', ((event) => {
              if (!this.props.autoPlay) {
                this.toggleVideoFlag(true, false);
              } else {
                this.toggleVideoFlag(true, true);
              }
            }), false);
            // tslint:disable:align
            docElement.addEventListener('hide.bs.modal', ((event) => {
              this.toggleVideoFlag(false, false);
            }), false);
          });
        }
      }
    } else {
      const newObj = Object.assign({}, this.state,  { listenersSet: false });
      if (this.isComponentMounted) {
        this.setState(newObj, () => {
          this.toggleVideoFlag(true, false);
        });
      }
    }
  }

  private toggleVideoFlag(showFlag: boolean, playFlag: boolean) {
    const newObj = Object.assign({}, this.state,  { showVideo: showFlag, playVideo: playFlag  });
    if (this.isComponentMounted) {
      this.setState(newObj);
    }
  }

  private getVideoPlayer() {
    return (
      <div className="react-player-wrapper">
        <ReactPlayer 
          className="react-player"
          url={this.props.videoUrl}
          playing={this.state.playVideo}
          controls={true}
          volume={1.0}
          width={'100%'}
          height={'100%'}
          config={{
            youtube: {
              playerVars: { fs: 0, modestbranding: 1 }
            },
            file: {
              attributes: { 
                poster: this.props.imgUrl,
                controlsList: 'nodownload'
              } 
            }
          }}
          onPlay={() => this.toggleVideoFlag(true, true)}
          onPause={() => this.toggleVideoFlag(true, false)}
          onProgress={(progress: any) => this.handleViewProgress(window, 'video', progress.played)}
        />
      </div>
    );
  }

  private handleViewProgress = (window: any, type: string, progressFraction: number) => {
    if (this.props.containerStore) {
      const newProps = {
        store: {
          Container: this.props.containerStore
        }
      };
      if (this.props.trackStudentTasks) {
        Helper.checkStudentTasks(newProps, window, type, this.props.videoUrl, progressFraction);
      } else if (this.props.trackStudentEmplSkills && this.props.trackStudentEmplSkillTopicId) {
        Helper.checkStudentEmplSkills(newProps, this.props.trackStudentEmplSkillTopicId, progressFraction);
      }
    }
  }
}

export default ViewVideo;
